import _ from 'lodash'

import {
  ModelViewer,
  Form,
  Input,
  Modal,
  Select,
  CountryCodeSelect,
  StateCodeSelect,
  DateInput,
  LoadingContainer,
} from 'peach/components'
import { useParams } from 'peach/router'

import { useInternalBorrowerGet, useInternalBorrowerUpdate } from 'core/types'
import { Page } from 'core/components'

const PersonRecord = () => {
  const { companyId, personId } = useParams<{
    companyId?: string
    personId?: string
  }>()

  const {
    data: person,
    isLoading,
    isError,
  } = useInternalBorrowerGet({ companyId, personId })

  const { borrowerType, status } = person ?? {}

  const pluckedName = _.pick(person?.object === 'person' ? person.name : null, [
    'prefix',
    'firstName',
    'middleName',
    'lastName',
    'maidenLastName',
    'suffix',
    'preferredFirstName',
  ])

  const { mutateAsync: updateBorrower } = useInternalBorrowerUpdate({
    companyId,
    personId,
  })

  return (
    <LoadingContainer error={isError} loading={isLoading}>
      <Page>
        <Modal
          action
          onRawSubmit={async (newBorrower) => {
            await updateBorrower(newBorrower)
          }}
          title='Edit Borrower'
          trigger
          value={{
            borrowerType,
            dateOfBirth:
              person?.object === 'person' ? person.dateOfBirth : null,
            status,
            name: pluckedName,
            businessDetails:
              person?.object === 'business' ? person.businessDetails : null,
          }}
        >
          <Select formKey='status' options={['active', 'inactive']} />

          <Form.If if={({ borrowerType }) => borrowerType !== 'business'}>
            <DateInput formKey='dateOfBirth' />
            <Form.Provider formKey='name' section>
              <Input formKey='prefix' />
              <Input formKey='firstName' />
              <Input formKey='middleName' />
              <Input formKey='lastName' />
              <Input formKey='maidenLastName' />
              <Input formKey='suffix' />
              <Input formKey='preferredFirstName' />
            </Form.Provider>
          </Form.If>

          <Form.If if={{ borrowerType: 'business' }}>
            <Form.Provider formKey='businessDetails' section>
              <Select
                formKey='businessType'
                options={[
                  'LLC',
                  'cCorporation',
                  'sCorporation',
                  'generalPartnership',
                  'limitedPartnership',
                  'soleProprietor',
                  'nonProfit',
                  'other',
                ]}
              />
              <Input formKey='businessName' />
              <Input formKey='businessLegalName' />
              <CountryCodeSelect formKey='incorporatedCountry' />
              <StateCodeSelect formKey='incorporatedState' />
            </Form.Provider>
          </Form.If>
        </Modal>
        <ModelViewer json={person} />
      </Page>
    </LoadingContainer>
  )
}

export default PersonRecord
